import React from 'react';

const StoneCard = ({ stone, index }) => {
  const isSintered = stone.name === 'Sintered Stone';

  return (
    <article className="group h-full flex flex-col">
      <div className="flex items-baseline gap-4 mb-3">
        <span className="section-num text-xs">0{index + 1}</span>
        <h3 className="font-serif text-2xl md:text-[28px] text-[#1a1a1a] group-hover:text-[#7B1E24] transition-colors duration-300">
          {stone.name}
        </h3>
      </div>

      <div className={`grid grid-cols-2 gap-3 mb-4 ${isSintered ? 'lg:gap-6' : ''}`}>
        {stone.images.map((src, idx) => (
          <div
            key={src}
            className={`img-zoom overflow-hidden rounded-sm ${
              isSintered ? 'aspect-[4/3] bg-white p-3 md:p-5' : 'aspect-[3/4] bg-[#F1EBE1]'
            }`}
          >
            <img
              src={src}
              alt={`${stone.name} sample ${idx + 1}`}
              loading="lazy"
              className={`w-full h-full ${isSintered ? 'object-contain' : 'object-cover'}`}
            />
          </div>
        ))}
      </div>

      <p className={`text-[#4a463f] text-[14.5px] leading-relaxed ${isSintered ? 'max-w-3xl' : ''}`}>
        {stone.description}
      </p>
    </article>
  );
};

export default StoneCard;
